import { useMemo } from 'react';
import { useSpotMarkets } from 'src/hooks/spotMarkets/useSpotMarkets';
import { usePerpMarkets } from 'src/hooks/perpMarkets/usePerpMarkets';
import { useVaultStats } from 'src/hooks/query/vaults/derived/useVaultStats';

export const useVaultAssetSymbols = (vaultPubkey: string) => {
	const spotMarkets = useSpotMarkets();
	const perpMarkets = usePerpMarkets();
	const { data: vaultStats } = useVaultStats(vaultPubkey);
	const uniqueAssetSymbols = useMemo(() => {
		const assetSymbols = new Set<string>();
		vaultStats?.metadata?.activePerpMarketIndexes.forEach((marketIndex) => {
			assetSymbols.add(perpMarkets[marketIndex].baseAssetSymbol);
		});
		vaultStats?.metadata?.activeSpotMarketIndexes.forEach((marketIndex) => {
			assetSymbols.add(spotMarkets[marketIndex].symbol);
		});
		return Array.from(assetSymbols);
	}, [vaultStats]);

	return uniqueAssetSymbols;
};
